import {
  Form,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Spin,
  Typography,
  Divider,
  Select,
  Collapse,
  Upload
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import { renderTrainerForm } from '../TrainerHelpers';

import { countryList } from '../../../data/countryList';
const { Panel } = Collapse;

const { Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

function BasicInfoEdit({
  type,
  isOpen,
  toggle,
  initialValues,
  onSubmit,
  status,
  onImageUpload,
  beforeImageUpload
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      profileImage: initialValues.profileImage
    });
  }, [initialValues]);

  return (
    <Modal
      title={type === 'ADD' ? 'Add Trainer' : 'Edit Basic info'}
      visible={isOpen}
      footer={null}
      onCancel={toggle}
      forceRender={true}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          onFinish={onSubmit}
          initialValues={initialValues}
          form={form}>
          {renderTrainerForm(form, onImageUpload)}
          {status.type === 'ERROR' ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === 'SUCCESS' ? (
            <Text type="success">Successfully Updated!</Text>
          ) : null}
          <Row justify="end">
            <Col>
              <Button type="primary" htmlType="submit">
                {type === 'ADD' ? 'Add' : 'Update'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
}

export default BasicInfoEdit;
